import Above from "core-web/components/Breakpoints/Above";
import Below from "core-web/components/Breakpoints/Below";
import React from "react";
import loadable from "@loadable/component";
import styled from "theme/libs/styled";
import { useSelector } from "react-redux";

const DefaultPlaceholder = styled("div")`
    width: 100%;
    height: ${({ theme }) => theme.variables.headerHeightMobile}px;

    ${({ theme }) => theme.above.tabletLg} {
        height: ${({ theme }) => theme.variables.headerHeight}px;
    }
`;

const CheckoutPlaceholder = styled("div")`
    width: 100%;
    height: ${({ theme }) => theme.variables.checkoutHeaderHeight};
`;

const DefaultDesktopHeader = loadable(() => import("./DesktopHeader"), {
    fallback: <DefaultPlaceholder />,
});

const DefaultMobileHeader = loadable(() => import("./MobileHeader"), {
    fallback: <DefaultPlaceholder />,
});

const CheckoutHeader = loadable(() => import("./CheckoutHeader"), {
    fallback: <CheckoutPlaceholder />,
});

const Header = () => {
    const isCheckout = useSelector(({ page }) => page.type === "storm_checkout");

    return isCheckout ? (
        <CheckoutHeader />
    ) : (
        <>
            <Below breakpoint="tabletLg" render={() => <DefaultMobileHeader />} />
            <Above breakpoint="tabletLg" render={() => <DefaultDesktopHeader />} />
        </>
    );
};

export default Header;
